export default "__VITE_ASSET__Y8uAq$sE__"